import { render, staticRenderFns } from "./EventOrders.vue?vue&type=template&id=7abe916f&"
import script from "./EventOrders.vue?vue&type=script&lang=js&"
export * from "./EventOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VChip,
  VContainer,
  VFlex,
  VLayout,
  VSwitch,
})
